import Component from 'gia/Component'
import render from '../components/render'
import stage from '../components/stage'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "../ScrollTrigger.js";
import { CustomWiggle } from "../CustomWiggle.js";
import { CustomEase } from "../CustomEase.js";
gsap.registerPlugin(ScrollTrigger, CustomEase, CustomWiggle);



class  Details extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)

    this.ref = {

    }
  }


  mount() {

     let mm = gsap.matchMedia();

     mm.add("(min-width: 768px)", () => {

         _each($('.details-out'), (el) => {
             ScrollTrigger.create({
                 trigger: el,
                 start: "bottom top+=50%",
                 toggleClass: 'out-view'
                 //markers: {startColor: "green", endColor: "red", fontSize: "12px"},
                 //onEnter: (self) => {
                 //console.log(el.dataset.color, "active:" + self.isActive)
                 //    $(el).addClass('in-view')
                 //}
             });
         })

          ScrollTrigger.create({
              trigger: ".tree-test",
              pin: true, // pin the trigger element while active
              start: "top top", // when the top of the trigger hits the top of the viewport
              end: "+=350%", // end after scrolling 500px beyond the start
              //scrub: .4, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
              //  markers: true,
              //  snap: {
              //      snapTo: .25, // snap to the closest label in the timeline
              //      duration: 0.3, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
              //      //delay: 0.2, // wait 0.2 seconds from the last scroll event before doing the snapping
              //      ease: "power1.inOut" // the ease of the snap animation ("power3" by default)
              //  }
          })


          gsap.fromTo(
              ".tree-test__content", {
                  yPercent: -100,
              }, {
                  yPercent: -66,
                  // yes, we can add it to an entire timeline!
                  scrollTrigger: {
                      trigger: ".self",
                      start: "top top+=50%",
                      end: "top top",
                      scrub: true

                  }
              }
          );

          gsap.fromTo(
              ".tree-test__content", {
                  yPercent: -66,
              }, {
                  yPercent: -33,
                  // yes, we can add it to an entire timeline!
                  scrollTrigger: {
                      trigger: ".trunk",
                      start: "top top+=50%",
                      end: "top top",
                      scrub: true

                  }
              }
          );

          gsap.fromTo(
              ".tree-test__content", {
                  yPercent: -33
              }, {
                  yPercent: 0,
                  // yes, we can add it to an entire timeline!
                  scrollTrigger: {
                      trigger: ".crown",
                      start: "top top+=50%",
                      end: "top top",
                      scrub: true

                  }
              }
          );

      });

     mm.add("(max-width: 767px)", () => {

     });

   

    

    


 

      _each($('.details-anim'), (el) => {
          ScrollTrigger.create({
              trigger: el,
              start: "top top+=75%",
              toggleClass: 'in-view',
              //markers: {startColor: "green", endColor: "red", fontSize: "12px"},
              onEnter: (self) => {
                 // console.log(el.dataset.element, "active:" + self.isActive)
                //  $(el).addClass('in-view')
                console.log(`.${el.dataset.element}`);
                if(el.dataset.element != undefined){
                    gsap.fromTo(`.${el.dataset.element}`, {scale: .8, opacity: 0}, {
                        opacity: 1,
                        stagger: .1, 
                        scale: 1
                    })

                    if (el.dataset.element == 'roots2'){
                        gsap.fromTo(['#roots1', '#roots2', '#roots3', '#roots4'], {
                            scale: .8,
                            opacity: 0
                        }, {
                            opacity: 1,
                            stagger: .1,
                            scale: 1
                        })
                    }


                }
              }, 
              onLeaveBack: (self) => {
                  //console.log(el.dataset.element, "active:" + self.isActive)
                  console.log('leave', el.dataset.element);
                  //  $(el).addClass('in-view')
                  if (el.dataset.element) {
                    gsap.fromTo(`.${el.dataset.element}`, {scale: 1, opacity: 1},  {
                        opacity: 0,
                        stagger: .1, 
                        scale: .8
                    })

                    if (el.dataset.element == 'roots2') {
                        gsap.fromTo(['#roots1', '#roots2', '#roots3', '#roots4'], {
                            scale: 1,
                            opacity: 1
                        }, {
                            opacity: 0,
                            stagger: .1,
                            scale: .8
                        })
                    }
                    }

                  console.log(`.${el.dataset.element}`);
              }

          });
      })

     

      _each($('.rb, lb'), (el) => {
          ScrollTrigger.create({
              trigger: el,
              start: "bottom top+=50%",
              toggleClass: 'out-view'
              //markers: {startColor: "green", endColor: "red", fontSize: "12px"},
              //onEnter: (self) => {
              //console.log(el.dataset.color, "active:" + self.isActive)
              //    $(el).addClass('in-view')
              //}
          });
      })
     

       gsap.set(".tree-test__content", {
           yPercent: -100
       })
         
        
    

  }

  unmount() {
    


  }

}

module.exports = Details
